import { AppEnvironment } from './environment.model';
import { environment as environmentBase } from './environment.erikorgu.prod';

export const environment: AppEnvironment = {
  ...environmentBase,
  BASE_HREF: '/app/en/',
  lang: 'en_GB',
  langShort: 'EN'
};
